import React from 'react';
import Zoom from 'react-reveal/Zoom';
import styles from './styles.module.scss';

function SkillComponent(props) {
	return (
		<Zoom>
			<div className={styles.gridItem}>
				{props.language ? (
					<>
						<img
							src={require('../../assets/Flags/' + props.lang + '.svg')}
							alt='lang flag'
						></img>
						<h4>{props.lang}</h4>
						<h5>{props.langDesc}</h5>
					</>
				) : (
					<>
						<i
							className={`${styles.skillIcon} ${props.skillIconName} colored`}
						></i>
						<h4>{props.skillName}</h4>
					</>
				)}
			</div>
		</Zoom>
	);
}

export default SkillComponent;
